/** IKEA article number as printed on the products: "20574587" → "205.745.87". */
export function formatArticle(ikeaId: string): string {
	return /^\d{8}$/.test(ikeaId)
		? `${ikeaId.slice(0, 3)}.${ikeaId.slice(3, 6)}.${ikeaId.slice(6)}`
		: ikeaId;
}
